/* eslint-disable react/no-string-refs */
import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Paper,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  SelectValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps as CampaignAction } from "../../redux/campaigns";
import { mapActionsToProps } from "../../redux/report/callGeneratorLog";

const styles = (theme) => ({
  charts: {
    backgroundColor: "#fff",
  },
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    justifyContent: "center",
    display: "flex",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
});

class CallGeneratorLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      minutes: "per30",
      item: null,
      modalAction: false,
      modalDelete: false,
      checkedA: false,
    };
  }
  async componentDidMount() {
    // this.itemInit();
    this.history = globalHistory();
    this.props.getListCampaigns();
    // this.interval = setInterval(() => {
    //     if (this.state.filters.where.gte == null || this.state.filters.where.lte == null && this.state.filters.where.campaignId !== null) {
    //         return (
    //             this.handleSubmit()
    //         )
    //     }
    // }, 60000);
  }

  // componentWillUnmount() {
  //     clearInterval(this.interval);
  // }

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "campaignId":
            default: {
              if (key.startsWith("gte")) {
                if (this.state.minutes == "per30") {
                  const per = datetimeHelper.subMinutesToDate(
                    this.state.filters.where.gte,
                    30
                  );
                  const time = datetimeHelper.toFormat(per, "YYYY-MM-DD HH:mm");
                  and.push(
                    { createdAt: { gte: time } },
                    { createdAt: { lte: this.state.filters.where.gte } }
                  );
                  filters.where.and = and;
                } else if (this.state.minutes == "after30") {
                  const next = datetimeHelper.AddMinutesToDate(
                    this.state.filters.where.gte,
                    30
                  );
                  const time = datetimeHelper.toFormat(
                    next,
                    "YYYY-MM-DD HH:mm"
                  );
                  and.push(
                    { createdAt: { gte: this.state.filters.where.gte } },
                    { createdAt: { lte: time } }
                  );
                  filters.where.and = and;
                }
              } else {
                // and.push({ createdAt: { gte: time } }, { createdAt: { lte: datetimeHelper.toFormat(new Date(), "YYYY-MM-DD HH:mm") } });
                where.and = and;
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.callGeneratorLog({ where });
  }

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = () => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (gte) => {
    const { filters } = this.state;
    filters.where.gte = gte;
    this.setState({ gte });
  };

  handleDateChangeEnd = (lte) => {
    const { filters } = this.state;
    filters.where.lte = datetimeHelper.toFormat(lte, "YYYY-MM-DD HH:mm");
    this.setState({ lte });
  };

  handleChange = (event) => {
    this.setState({ checkedA: event.target.checked });
  };

  handleChangeText = (name) => {
    return (e) => {
      return this.setState({
        [name]: e.target.value,
      });
    };
  };

  render() {
    const { classes, listCallGeneratorLog, listCampaign } = this.props;
    const { filters } = this.state;
    const listCallGeneratorLogResult =
      typeof listCallGeneratorLog === "object"
        ? Object.keys(listCallGeneratorLog).map(
            (key) => listCallGeneratorLog[key]
          )
        : listCallGeneratorLog;
    const listCampaignResult =
      typeof listCampaign === "object"
        ? Object.keys(listCampaign).map((key) => listCampaign[key])
        : listCampaign;
    let dataAsr = [];
    let dataCpa = [];
    let dataAnswer = [];
    let dataDtv = [];
    let dataRing = [];
    let dataTime = [];
    for (const key in listCallGeneratorLogResult) {
      if (listCallGeneratorLogResult.hasOwnProperty(key)) {
        const value = listCallGeneratorLogResult[key];
        if (value !== undefined) {
          dataAsr.push([
            parseFloat(
              value.data.asr !== undefined ? value.data.asr.toFixed(2) : 0
            ),
          ]);
          dataCpa.push([
            parseFloat(
              value.data.cpa !== undefined ? value.data.cpa.toFixed(2) : 0
            ),
          ]);
          dataAnswer.push([
            value.data !== undefined ? value.data.calls.answer.total : 0,
          ]);
          dataDtv.push([
            value.data !== undefined ? value.data.agents.telesales : 0,
          ]);
          dataRing.push([
            value.data !== undefined ? value.data.calls.ring.total : 0,
          ]);
          dataTime.push([
            datetimeHelper.toFormat(value.createdAt, "YYYY-MM-DD HH:mm"),
          ]);
        }
      }
    }
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ alignItems: "center" }}>
                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          select
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Chọn chiến dịch"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleSearch}
                          value={filters.where.campaignId}
                          name="campaignId"
                          validators={["required"]}
                          errorMessages={"Không được để trống"}>
                          {listCampaignResult
                            ? listCampaignResult.map((item) => {
                                return (
                                  <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                  </MenuItem>
                                );
                              })
                            : null}
                        </SelectValidator>
                      </Grid>
                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.gte}
                          format="dd-MM-yyyy HH:mm"
                          onChange={this.handleDateChangeStart}
                          maxDate={new Date()}
                          name="gte"
                          keyboard
                          required
                          ampm={false}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <SelectValidator
                          id="outlined-full-width"
                          margin="normal"
                          select
                          SelectProps={{
                            MenuProps: {
                              className: classes.menu,
                              shrink: true,
                            },
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Chọn giới hạn"
                          variant="outlined"
                          className={classes.input}
                          onChange={this.handleChangeText("minutes")}
                          value={this.state.minutes}
                          name="minutes"
                          validators={["required"]}
                          errorMessages={"Không được để trống"}>
                          <MenuItem key="per30" value="per30">
                            30 phút trước
                          </MenuItem>
                          <MenuItem key="after30" value="after30">
                            30 phút sau
                          </MenuItem>
                        </SelectValidator>
                      </Grid>
                      <Grid item md={3}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                      <FormControlLabel
                        style={{ marginLeft: "-4px" }}
                        control={
                          <Checkbox
                            checked={this.state.checkedA}
                            onChange={this.handleChange}
                            value="checkedA"
                            color="primary"
                            inputProps={{
                              "aria-label": "secondary checkbox",
                            }}
                          />
                        }
                        label="Hiển thị bảng dữ liệu"
                      />
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <div style={{ marginTop: 10 }}>
          {listCallGeneratorLogResult.length !== 0 ? (
            <HighchartsReact
              highcharts={Highcharts}
              options={{
                title: {
                  text: "",
                },
                series: [
                  {
                    name: "ASR(%)",
                    data: dataAsr,
                  },
                  {
                    name: "CPA (call per agent)",
                    data: dataCpa,
                  },
                  {
                    name: "ĐTV telesales",
                    data: dataDtv,
                  },
                  {
                    name: "Tổng cuộc gọi ra trả lời",
                    data: dataAnswer,
                  },
                  {
                    name: "Tổng cuộc gọi đang kết nối",
                    data: dataRing,
                  },
                ],
                xAxis: {
                  title: {
                    text: "Thời gian",
                  },
                  type: "datetime",
                  categories: dataTime,
                  tickInterval: 3600,
                  tickWidth: 0,
                  gridLineWidth: 1,
                },

                yAxis: [
                  {
                    // left y axis
                    title: {
                      text: "Tỉ lệ (%)",
                    },

                    showFirstLabel: false,
                  },
                  {
                    // right y axis
                    linkedTo: 0,
                    gridLineWidth: 0,
                    opposite: true,
                    title: {
                      text: "Cuộc gọi",
                    },

                    showFirstLabel: false,
                  },
                ],

                legend: {
                  align: "left",
                  verticalAlign: "top",
                  borderWidth: 0,
                },

                tooltip: {
                  shared: true,
                  crosshairs: true,
                },

                plotOptions: {
                  series: {
                    marker: {
                      enabled: false,
                    },
                  },
                },
              }}
            />
          ) : // <Paper className={classes.root}>
          //     <Grid container spacing={4} style={{ padding: 40 }}>
          //         <Chart
          //                 width={'100%'}
          //                 height={'500px'}
          //                 chartType="Line"
          //                 loader={<div>Loading Chart</div>}
          //                 data={data}
          //                 options={{
          //                     series: {
          //                         0: { axis: 'ASR' },
          //                         0: { axis: 'Calls' },
          //                     },
          //                     axes: {
          //                         y: {
          //                             ASR: { label: 'Tỉ lệ (%)' },
          //                             Calls: { label: 'Cuộc gọi' },
          //                         },
          //                     },
          //                     crosshair: {
          //                         color: '#000',
          //                         trigger: 'selection'
          //                     }
          //                 }}
          //                 rootProps={{ 'data-testid': '1' }}
          //             />
          //     </Grid>
          // </Paper>
          null}
        </div>
        <Paper className={classes.root}>
          <Grid container>
            {this.state.checkedA == true ? (
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell
                      rowSpan={3}
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Chiến dịch
                    </TableCell>
                    <TableCell
                      rowSpan={3}
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Thời gian
                    </TableCell>
                    <TableCell
                      rowSpan={3}
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      ASR (%)
                    </TableCell>
                    <TableCell
                      rowSpan={3}
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Số cuộc gọi trên mỗi điện thoại viên
                    </TableCell>
                    <TableCell
                      colSpan="5"
                      rowSpan={2}
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Điện thoại viên
                    </TableCell>
                    <TableCell
                      colSpan="11"
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Cuộc gọi
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      rowSpan="2"
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Được tạo
                    </TableCell>
                    <TableCell
                      colSpan="5"
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Nghe máy
                    </TableCell>
                    <TableCell
                      colSpan="5"
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Đang ring
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Available
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Pause
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Service
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Stop
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Telesales
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Tổng
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      00 - 20 (giây)
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      20 - 40 (giây)
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      40 - 60 (giây)
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      {" "}
                      {">"} 60 (giây)
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      Tổng
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      00 - 20 (giây)
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      20 - 40 (giây)
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      40 - 60 (giây)
                    </TableCell>
                    <TableCell
                      style={{
                        borderRight: "1px solid rgba(224, 224, 224, 1)",
                      }}>
                      {" "}
                      {">"} 60 (giây)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listCallGeneratorLogResult
                    ? listCallGeneratorLogResult.map((row, key) => {
                        return (
                          <TableRow key={key} style={{ whiteSpace: "nowrap" }}>
                            {row.groups.campaign.index === 0 ? (
                              <TableCell
                                component="th"
                                scope="row"
                                rowSpan={row.groups.campaign.count}
                                style={{
                                  borderRight:
                                    "1px solid rgba(224, 224, 224, 1)",
                                  paddingRight: "14px",
                                }}>
                                {row.campaign ? row.campaign.name : ""}
                              </TableCell>
                            ) : (
                              <React.Fragment />
                            )}
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {datetimeHelper.toFormat(
                                row.createdAt,
                                "YYYY-MM-DD HH:mm:ss"
                              )}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.asr !== undefined
                                ? row.data.asr.toFixed(1)
                                : ""}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.cpa !== undefined
                                ? row.data.cpa.toFixed(1)
                                : ""}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.agents.available}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.agents.pause}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.agents.service}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.agents.stop}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.agents.telesales}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.calls.generatedCalls}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.calls.answer.total}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.calls.answer.a00to20}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.calls.answer.a20to40}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.calls.answer.a40to60}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.calls.answer.a60}
                            </TableCell>

                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.calls.ring.total}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.calls.ring.r00to20}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.calls.ring.r20to40}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.calls.ring.r40to60}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              style={{
                                borderRight: "1px solid rgba(224, 224, 224, 1)",
                              }}>
                              {row.data.calls.ring.r60}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
            ) : null}
          </Grid>
        </Paper>
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

CallGeneratorLog.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listCallGeneratorLog: state.callGeneratorLog.data,
  loading: state.callGeneratorLog.loading,
  listCampaign: state.campaign.campaigns,
});

CallGeneratorLog = connect(null, mapActionsToProps)(CallGeneratorLog);
const Campaigns = connect(mapStateToProps, CampaignAction)(CallGeneratorLog);

export default withStyles(styles)(Campaigns);
